<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-row>
          <b-col cols="12">
            <title-text />
          </b-col>
          <b-col cols="12">
            <url />
          </b-col>
          <b-col cols="12">
            <ordering />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col cols="12">
      <logo-card />
    </b-col>
    <b-col cols="12">
      <b-button
        variant="primary"
        :disabled="itemData.submitStatus"
        @click="submitForm"
      >
        Kaydet
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/References/elements/Title.vue'
import Url from '@/views/Admin/References/elements/Url.vue'
import Ordering from '@/views/Admin/References/elements/Ordering.vue'
import LogoCard from '@/views/Admin/References/elements/LogoCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    Ordering,
    Url,
    LogoCard,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['references/dataItem']
    },
  },
}
</script>
